"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7509],{

/***/ 7509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GarageProfileOfferings": function() { return /* binding */ GarageProfileOfferings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileExpertise.tsx





var GarageProfileExpertise = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GarageProfileExpertise, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GarageProfileExpertise);
    function GarageProfileExpertise() {
        (0,_class_call_check/* default */.Z)(this, GarageProfileExpertise);
        return _super.apply(this, arguments);
    }
    var _proto = GarageProfileExpertise.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-full mb-6 md:mb-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-gradient-to-r from-emerald-300 to-emerald-400 px-4 py-1 rounded-md flex items-center w-fit",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa-kit fa-bolt fa-fw text-green text-lg mr-3 inline-block"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "textContentContainer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base leading-6 font-normal text-green-900",
                                children: "E-Ready"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base leading-6 font-medium text-green-900",
                                children: "Elektro & Hybrid Fahrzeuge werden angenommen"
                            })
                        ]
                    })
                ]
            })
        });
    };
    return GarageProfileExpertise;
}(react.PureComponent);

;// CONCATENATED MODULE: ./icons.ts
var icons = {
    // main
    "faGarageCar": "garage-car" || 0,
    // services
    "faTemperatureSnow": "temperature-snow",
    "faEngine": "engine",
    "faClipboardListCheck": "clipboard-list-check",
    "faTire": "tire",
    "faGears": "gears",
    "faCarWrench": "car-wrench",
    "faSteeringWheel": "steering-wheel",
    "faEngineWarning": "engine-warning",
    "faBagel": "bagel",
    "faScrewdriverWrench": "wrench",
    "faToolbox": "toolbox",
    "faOilCanDrip": "oil-can-drip",
    // badges
    "faLocationCheck": "location-check",
    "faPiggyBank": "piggy-bank",
    "faCalendarDay": "calendar-day",
    "faTrophyStar": "trophy-star",
    // list buttons
    "faMagnifyingGlass": "magnifying-glass"
};

// EXTERNAL MODULE: ./node_modules/@eo-locale/react/lib/index.js + 1 modules
var lib = __webpack_require__(7245);
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileOfferings.tsx





var GarageProfileOfferings = /*#__PURE__*/ react.memo(function(param) {
    var garage = param.garage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "garageProfile__offerings col-span-full mb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-2xl md:text-3xl font-serif mb-8 text-gray-900",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                    id: "garage_offerings"
                })
            }),
            garage.supports_bev && /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileExpertise, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-lg font-semibold font-serif mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                    id: "services"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "grid grid-cols-2 mb-1",
                children: garage.availableServices && garage.availableServices.map(function(service, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "col-span-2 md:col-span-1 mb-3 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-kit fa-fw text-primary text-2xl fa-".concat(icons[service.icon], " align-middle mr-3 relative")
                            }),
                            service.name
                        ]
                    }, service.id);
                })
            })
        ]
    });
});
GarageProfileOfferings.displayName = "GarageProfileOfferings";


/***/ })

}]);